import type { ApiLogsFilterState } from '../types/filters'

export function countActiveApiLogsFilters(
  filters: ApiLogsFilterState & { q?: string },
): number {
  let count = 0
  if (filters.q?.trim()) count += 1
  if (filters.fromDt || filters.toDt) count += 1
  return count
}
